import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const SiteVisitDetailsRecordedTaskAttemptSchema = z.object({
  type: z.literal(TaskType.SITE_VISIT_DETAILS_RECORDED),
  descriptionOfSiteVisit: z.string(),
  onsiteRepairsPerformed: z.boolean(),
  panelsRemoved: z.number().nullable(),
  panelsReinstalled: z.number().nullable(),
  costOfRepairs: z.number().nullable(),
  receiptFileIds: z.array(z.string()),
  isItelRequested: z.boolean().optional(),
  itelOverrideReason: z.string().optional(),
});

export type SiteVisitDetailsRecordedTaskAttempt = z.infer<typeof SiteVisitDetailsRecordedTaskAttemptSchema>;
